// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xk_a bho_vp bho_vh bho_xe bho_rg bho_tr bho_qx"};